import { Logger } from "./logger";

interface IUrlSearchParamUtils {
    (url: string | null, params: string[]): Record<string, string | null> | undefined;
}

export const UrlSearchParamUtils: IUrlSearchParamUtils = (url, params) => {
    if (!url || !params) {
        Logger.captureError(new Error(`Invalid url or params`));
        return;
    }
    if (typeof url !== 'string') {
        Logger.captureError(new Error(`Invalid url. Url is ${typeof url}. Expected string`));
        return;
    }
    if (!Array.isArray(params)) {
        Logger.captureError(new Error(`Invalid params. Params is ${typeof params}. Expected array`));
        return;
    }
    if (!params.length) {
        Logger.captureError(new Error(`Invalid params. Params is empty`));
        return;
    }
    
    const urlObject = new URL(url);
    const result = params.reduce<Record<string, string | null>>((acc, param) => {
        acc[param] = urlObject.searchParams.get(param);
        return acc;
    }, {});
    return result;
};
